import React, { useState } from "react";
import { ImageOff } from "lucide-react";

export default function ListingImage({ src, alt, position = "center", className = "", eager = false }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  return <div className={`listing-media ${className}`}>
    {src && !failed ? <>
      {!loaded && <span className="media-loading" aria-label="Loading image" />}
      <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} onLoad={() => setLoaded(true)} onError={() => setFailed(true)} style={{ objectPosition: position, opacity: loaded ? 1 : 0 }} />
    </> : <div className="media-fallback"><ImageOff size={26} /><span>Whitefield, worth exploring</span><small>Photo coming soon</small></div>}
  </div>;
}
